/**
 * 验证手机格式
 */
export function mobileValide(value) {
  return /^1[23456789]\d{9}$/.test(value)
}

export function idCardValide(value) {
  return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
    value
  );
  // return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
  //   value
  // );
}
